var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1=" <a name=\"reservation-part-extraservices\" id=\"reservation-part-extraservices\"></a> <web-component> <winres-transport dest-code=\"{{ $ctrl.destCode }}\" begin-date=\"{{ $ctrl.beginDate }}\" end-date=\"{{ $ctrl.endDate }}\" passengers=\"$ctrl.passengers\" product-lines=\"$ctrl.transportProductLines\" on-change=\"$ctrl.onChange(valid, complexProductLines)\"> </winres-transport> <winres-reservation-button is-pay-button=\"true\"></winres-reservation-button> </web-component>";
var id1="winresTransportWrapper.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresTransportWrapper/winresTransportWrapper.html
// module id = 482
// module chunks = 2